export default class EventVisitHistoryRepo
{
  constructor(key = 'event-visit-history-repo', count = 0)
  {
    this.key = key;
    this.count = count < 0 ? 0 : count;
  }

  load()
  {
    const saved = localStorage.getItem(this.key);

    if (!saved) {
      return [];
    }

    let parsed;
    try {
      parsed = JSON.parse(saved);
    } catch (e) {
      // Сохранено что-то неправильное
      parsed = null;
    }

    if (!Array.isArray(parsed)) {
      // Можно выбросить ошибку
      return [];
    }

    return parsed.filter(({ id, code, title }) => id && title);
  }

  save(item)
  {
    const { key, count } = this;
    const list = this.load().filter(saved => saved.id !== item.id);
    list.push(item);
    localStorage.setItem(key, JSON.stringify(list.slice(-count)));
  }

  clear()
  {
    localStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// ./src/providers/EventVisitHistoryRepo.js